import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonInput, CustomPagination, NoDataFound } from 'components'
import StorageService from "utils/StorageServices/StorageServices";
import { Link, useNavigate } from 'react-router-dom';
import BootstrapTable from 'components/BootstrapTable';
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { utils } from 'helper';
import { getFirm, getToFirm } from '_services/accountsServices/firmServices';
import { AddAssociateFirmModal } from 'modals';
import RupeeIcon from 'pages/User/RupeeIcon';
import Loading from 'pages/Loading';

const InterFirmList = (props) => {
    const { firmDetails, firmDataLists } = props;
    useDocumentTitle("Inter Firm | T360");
    const navigate = useNavigate()
    const { masterData } = useContext(UserContext);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [firmDataList, setFirmDataList] = useState([])
    const [loading, setLoading] = useState(false);
    const prevFilterRef = useRef();
    const [associationOpen, setAssociationOpen] = useState(false);
    const [selectedAssociation, setSelectedAssociation] = useState(null);
    const [modalMode, setModalMode] = useState("add"); // "add", "view", "edit"
    const [searchTerm, setSearchTerm] = useState('');

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    // Debounce effect for search
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setFilter((s) => ({ ...s, search: searchTerm, offset: 1 }));
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    // Add new association
    const toggleFirmModelData = () => {
        setSelectedAssociation(null);
        setModalMode("add");
        setAssociationOpen(true);
    };

    // View association (read-only)
    const handleView = (item) => {
        setSelectedAssociation(item);
        setModalMode("view");
        setAssociationOpen(true);
    };

    // Edit association (editable from start)
    const handleEdit = (item) => {
        setSelectedAssociation(item);
        setModalMode("edit");
        setAssociationOpen(true);
    };

    const getDataFirmToList = async (firm_id, action = "") => {


        try {
            let object = {
                ...filter,
                from_firm_id: firm_id,
                company_id: StorageService.getCompanyId(),
            }

            if (action != "new") {
                setLoading(true)
            }

            const res = await getToFirm(object);

            if (res?.responseCode == 200) {
                setLoading(false)
                setFirmDataList(res?.data?.list);
                setTotalItems(res?.data?.total_record);
            } else {
                setLoading(false)
            }
        } catch (error) {
            // throw error;
            setLoading(false)
        }
    }

    const CallBackApi = () => {
        getDataFirmToList(firmDetails?._id,"new");
    }

    const handleCloseModal = () => {
        setAssociationOpen(false);
        setSelectedAssociation(null);
        setModalMode("add");
    };

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (firmDetails?._id) {
            getDataFirmToList(firmDetails?._id,"");
            prevFilterRef.current = filter;
        }
    }, [filter, firmDetails])

    const columns = [
        { header: "Firm Name", accessor: "name" },
        { header: "Balance", accessor: "balanceNu" },
        { header: "Action", accessor: "action" }
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            name: <span className='_tblText _style_ancer' onClick={() => navigate(`/accounting/interfirm/details/${item?._id}`)}>
                <a className='_avPointer'>
                    {item?.to_firm?.firm ? item?.to_firm?.firm : '-'} &nbsp;
                </a>
            </span>,
            // balanceNu: <>{item?.opening_balance ? item?.opening_balance : '-'}</>,
            balanceNu: item.balance ? (
                <Link
                    to={`details/${item?._id}`}
                    style={{ textDecoration: 'none' }}
                >
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        color: item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec'
                    }}>
                        <span>
                            <RupeeIcon
                                color={item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec'}
                                size={20}
                            />
                        </span>
                        <span>
                            {Math.abs(item.balance).toFixed(2)}
                        </span>
                    </div>
                </Link>
            ) : (
                <Link
                    to={`details/${item?._id}`}
                    style={{ textDecoration: 'none' }}
                >
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        color: '#1450ec'
                    }}>
                        <span>
                            <RupeeIcon
                                color='#1450ec'
                                size={20}
                            />
                        </span>
                        <span>
                            0
                        </span>
                    </div>
                </Link>
            )
            ,

            action: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "100px" }}>
                    {/* View Icon - Opens in view mode (read-only) */}
                    <div className='_avPointer' onClick={() => handleView(item)}>
                        <span className='_samAnchor'>
                            <span className='viewIcon_avt'>
                                <AiOutlineEye color='green' />
                            </span>
                        </span>
                    </div>

                    {/* Edit Icon - Opens in edit mode (editable) */}
                    <div className='_avPointer' onClick={() => handleEdit(item)}>
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color='blue' />
                            </span>
                        </span>
                    </div>
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const onNoDataAction = () => {
        setSelectedAssociation(null);
        setModalMode("add");
        setAssociationOpen(true);
    };

    const noDataMessage = "No firm Found"
    const noDataActionText = "Add Association"

    let firstAddBank = {
        isOpen: selectedAssociation || associationOpen,
        closeModal: handleCloseModal,
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        firmList: firmDataLists,
        toFirmList: firmDataList,
        currentFirmDetails: firmDetails,
        CallBackApi: CallBackApi,
        modalTitle: modalMode === "add" ? "Add Association" : modalMode === "view" ? "View Association" : "Edit Association",
        submitTitle: modalMode === "add" ? "Add" : modalMode === "view" ? "Add" : "Update",
        mode: modalMode
    };

    return (
        <div className="__profilCmp_main">
            <ButtonHeading
                title={"Inter Firm"}
                onClick={toggleFirmModelData}
                buttonTitle="+ Add Association"
                showSearchFilter={{ search: false, filterOption: false, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={true}
                className="inter_Firm_class"
            />

            <div className='pd_manufactoer'>
                <div className='__filtsTb_flexMain'>
                    <div className='__filtsTb_flex'>
                        <div className='__fInx_bx'>
                            <CommonInput
                                type="search"
                                label='Search Firms'
                                placeholder='Search Firms'
                                name='search'
                                value={searchTerm}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* {loading ? <div className='_tabWith_outTab'><div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> <Loading /></div>    </div> : */}
            <div className='_tabWith_outTab'>
                {firmDataList?.length != 0 ? <BootstrapTable
                    columns={columns}
                    data={rowListData(firmDataList?.length > 0 ? firmDataList : [])}
                    isLoading={loading}
                />
                    :
                    <NoDataFound
                        message={noDataMessage}
                        actionText={noDataActionText}
                        onActionClick={onNoDataAction}
                    />}
            </div>

            {associationOpen && <AddAssociateFirmModal {...firstAddBank} />}
        </div>
    )
}

export default InterFirmList